var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.05 50.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #000;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.02,0h0S0,.01,0,.01v50.03s50.03,0,50.03,0h0s.02,0,.02,0V0s-50.03,0-50.03,0Zm48.74,48.76H2.18s5.11-5.11,5.11-5.11h35.91s0-1.26,0-1.26H7.71s0-35.48,0-35.48h-1.26s0,35.8,0,35.8l-5.16,5.15V1.28s47.47,0,47.47,0v47.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.72,12.28H12.45s-.04,0-.05.02h-.02s0,.02,0,.02c-.01.02-.02.04-.02.05v25.28s0,.04.02.05v.04s25.45,0,25.45,0v-20.69s-12.86,0-12.86,0v1.32s11.54,0,11.54,0v18.05s-22.81,0-22.81,0V13.62s24.13,0,24.13,0v-1.32s-.06,0-.06,0c-.01,0-.03-.02-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.38,
    y: 16.07,
    width: 1.32,
    height: 17.71,
    transform: "translate(-10.58 24.3) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6231fb8f6a20e86272bf7f8810388445.svg";
export { ForwardRef as ReactComponent };